/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OverrideAnalysisResult200ResponseData } from './OverrideAnalysisResult200ResponseData';
import {
    OverrideAnalysisResult200ResponseDataFromJSON,
    OverrideAnalysisResult200ResponseDataFromJSONTyped,
    OverrideAnalysisResult200ResponseDataToJSON,
} from './OverrideAnalysisResult200ResponseData';

/**
 * 
 * @export
 * @interface OverrideAnalysisResult200Response
 */
export interface OverrideAnalysisResult200Response {
    /**
     * 
     * @type {OverrideAnalysisResult200ResponseData}
     * @memberof OverrideAnalysisResult200Response
     */
    data?: OverrideAnalysisResult200ResponseData;
}

/**
 * Check if a given object implements the OverrideAnalysisResult200Response interface.
 */
export function instanceOfOverrideAnalysisResult200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OverrideAnalysisResult200ResponseFromJSON(json: any): OverrideAnalysisResult200Response {
    return OverrideAnalysisResult200ResponseFromJSONTyped(json, false);
}

export function OverrideAnalysisResult200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideAnalysisResult200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : OverrideAnalysisResult200ResponseDataFromJSON(json['data']),
    };
}

export function OverrideAnalysisResult200ResponseToJSON(value?: OverrideAnalysisResult200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': OverrideAnalysisResult200ResponseDataToJSON(value.data),
    };
}

